//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from 'vue-click-outside';
import {
  faAngleDown,
} from '@fortawesome/pro-regular-svg-icons';

import channelTypesMixin from '@motionelements/core/src/components/mixins/channelTypes.mixin.js';

export default {
  name: 'FreeMediaTypesDropdown',
  props: {
    chosenMediaType: {
      type: String,
      required: true,
    },
  },
  directives: {
    ClickOutside,
  },
  mixins: [channelTypesMixin],
  data() {
    return {
      faAngleDown,
      isDropdownOpen: false,
    };
  },
  methods: {
    mediaTypeTitle(mediaTypeId) {
      return this.getChannelTypeName(mediaTypeId);
    },
    setMediaType(mediaType) {
      this.$router.push(this.$link(mediaType.freeLink).fullPath());
      this.isDropdownOpen = false;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    clickOutside() {
      this.isDropdownOpen = false;
    },
  },
};
